import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import { DashboardT } from 'business/definitions';
import { FilterOption } from 'components/DashboardSendModal/types';
import { trackEvent } from 'helpers/trackerHelpers';
import PdfPreviewModal from 'components/PdfPreviewModal/PdfPreviewModal';
import { PdfPreviewText } from 'routes/Dashboard/components/PdfPreviewText';
import InfoModal from 'components/SharedComponents/Modals/InfoModal';

import previewEmail from 'assets/preview_mail.png';
import Flex from 'ui/Flex/Flex';
import { useTranslation } from 'react-i18next';

type Props = {
    dashboard: DashboardT;
    filterOption: FilterOption;
};

const EmailPreviews = ({ dashboard, filterOption }: Props) => {
    const { t } = useTranslation();

    const [openEmailPreview, setOpenEmailPreview] = useState(false);
    const [openPDFPreview, setOpenPDFPreview] = useState(false);

    const showEmailPreview = () => setOpenEmailPreview(true);
    const showPDFPreview = () => setOpenPDFPreview(true);

    const isPdfDisabled =
        filterOption === FilterOption.DEFAULT_FILTERS_RECIPIENT_SCOPES;

    return (
        <Flex>
            <Button onClick={showEmailPreview}>
                {t('sendDashboard.mailPreview')}
            </Button>

            <Tooltip
                title={
                    isPdfDisabled
                        ? t(
                              'sendDashboard.onlyInternalRecipientsPreviewTooltip',
                          )
                        : ''
                }
            >
                <span>
                    <Button
                        onClick={() => {
                            trackEvent(
                                'decision/dashboard/options/send/nouvel-envoi/aperçu-pdf-click',
                                {
                                    dashboard: dashboard.key,
                                },
                            );
                            showPDFPreview();
                        }}
                        disabled={isPdfDisabled}
                    >
                        {t('sendDashboard.pdfPreview')}
                    </Button>
                </span>
            </Tooltip>

            {openEmailPreview && (
                <InfoModal
                    isOpen={openEmailPreview}
                    title={t('sendDashboard.mailTemplateMessage')}
                    onClose={() => setOpenEmailPreview(false)}
                >
                    <img
                        src={previewEmail}
                        alt="email preview"
                        width="500"
                        height="600"
                    />
                </InfoModal>
            )}

            {openPDFPreview && (
                <PdfPreviewModal
                    open={openPDFPreview}
                    url={`explore/dashboard/${dashboard.key}/pdf${
                        filterOption ===
                        FilterOption.DEFAULT_FILTERS_SENDER_SCOPES
                            ? '?force_default_filters=true'
                            : ''
                    }`}
                    onClose={() => setOpenPDFPreview(false)}
                    title={t('sendDashboard.waitForPreview')}
                    downloadTitle={dashboard.title}
                    onSuccessText={<PdfPreviewText />}
                    shouldDisplayFixedWidthText={dashboard.isFullWidth}
                />
            )}
        </Flex>
    );
};

export default EmailPreviews;
